import styled from "@emotion/styled";

import {
  AdSlotContainer,
  StyledSlot,
} from "scmp-app/components/advertisement/ad-slots/ad-slot/styles";

export const AdSlot = styled.div`
  && ${AdSlotContainer} {
    display: flex;
    align-items: flex-start;

    block-size: 100%;

    ${StyledSlot} {
      block-size: auto;
    }
  }
`;

export const WidgetContainer = styled.div``;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;

  inline-size: 100%;
  max-inline-size: 500px;

  background-color: #ffffff;

  ${AdSlot} {
    margin-block-start: 12px;
  }

  :has(${WidgetContainer}:empty) {
    display: none;
  }
`;
